//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

export const ERoutesRoot = {
  Dashboard:   '/dashboard',
  Datasets:    '/datasets',
  Explorer:    '/explorer',
  Graphs:      '/graphs',
  Jobs:        '/jobs',
  Login:       '/',
  LaunchNotes: '/launchNotes',
  // Legacy routes kept as redirects to Graphs, which combines both pages.
  Schemas:     '/schemas',
  TermsOfUse:  '/terms',
  Upload:      '/upload'
} as const;

export type ERoutesRoot = typeof ERoutesRoot[keyof typeof ERoutesRoot];
